function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.0149,
  cy: 17.0149,
  r: 17.0149,
  fill: "#FFDC4A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4399 8.50708C16.0138 8.50644 14.6129 8.88334 13.3797 9.59948C12.1464 10.3156 11.1247 11.3455 10.4183 12.5844C9.71201 13.8233 9.34624 15.2271 9.35819 16.6532C9.37015 18.0793 9.75941 19.4768 10.4864 20.7037L9.40268 23.6852C9.3623 23.7962 9.34925 23.9152 9.36464 24.0323C9.38004 24.1494 9.42342 24.261 9.49111 24.3577C9.5588 24.4545 9.6488 24.5335 9.75351 24.5881C9.85821 24.6426 9.97452 24.6712 10.0926 24.6713C10.1783 24.671 10.2633 24.6561 10.3439 24.6272L13.3254 23.5427C14.3955 24.1766 15.5974 24.555 16.8376 24.6484C18.0778 24.7418 19.3228 24.5478 20.4758 24.0813C21.6287 23.6149 22.6585 22.8887 23.4848 21.9592C24.3112 21.0297 24.9119 19.922 25.2402 18.7224C25.5685 17.5228 25.6154 16.2636 25.3775 15.0429C25.1395 13.8221 24.6231 12.6728 23.8683 11.6843C23.1135 10.6958 22.1407 9.89481 21.0257 9.34373C19.9108 8.79266 18.6837 8.50635 17.4399 8.50708Z",
  fill: "#AD8D07"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6609 18.7161C14.0252 18.7161 13.6345 19.3859 14.0766 19.8427C14.9273 20.7218 16.1196 21.2683 17.4395 21.2683C18.7593 21.2683 19.9516 20.7218 20.8023 19.8427C21.2444 19.3859 20.8538 18.7161 20.218 18.7161H14.6609Z",
  fill: "#FFDC4A"
});

function SvgSpeakingChallenge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgSpeakingChallenge);
export default __webpack_public_path__ + "static/media/speaking-challenge.62116147.svg";
export { ForwardRef as ReactComponent };